import { toast } from 'sonner'

export const handleCheckoutReturnParams = (): boolean => {
  const params = new URLSearchParams(window.location.search)
  const hasCheckoutParam = params.has('session_id') || params.has('checkout_completed')

  if (!hasCheckoutParam) return false

  params.delete('session_id')
  params.delete('checkout_completed')
  const cleanUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname
  window.history.replaceState({}, '', cleanUrl)
  toast.success('Payment completed successfully')
  return true
}
